import { getPublicBucketInfo} from '@/api'
import { axios } from "@/utils/request";

function random_string(len) {
  len = len || 32
  let chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
  let maxPos = chars.length
  let pwd = ''
  for (let i = 0; i < len; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * maxPos))
  }
  return pwd
}

export function uploadPublic(file, func) {
  getPublicBucketInfo({}).then(res => {
    console.log(res)
    if(res.success) {
      const result = res.data
      let suffix = file.name.substring(file.name.indexOf('.'))
      let key = result.dir + random_string(16) + suffix
      let formData = new FormData()
      console.log('key:', key)
      formData.append('key', key)
      formData.append('signature', result.signature)
      formData.append('OSSAccessKeyId', result.accessId)
      formData.append('policy', result.policy)
      // formData.append('success_action_status', '200')
      formData.append('file', file)
      axios.post(result.host, formData).then(() => {
        return func(result.host+'/'+key)
      })
    }
  })
}
